import { LuBuilding2 } from "react-icons/lu";
import { HiOutlineMap } from "react-icons/hi2";
import { TbFileSearch } from "react-icons/tb";

export type ChildSearchTab = "lea" | "state" | "match";

interface ChildSearchTabsProps {
  activeTab: ChildSearchTab;
  onTabChange: (tab: ChildSearchTab) => void;
}

export function ChildSearchTabs({
  activeTab,
  onTabChange,
}: ChildSearchTabsProps) {
  const tabs = [
    {
      id: "lea" as ChildSearchTab,
      label: "LEA Search",
      icon: <LuBuilding2 size={16} />,
    },
    {
      id: "state" as ChildSearchTab,
      label: "State Search",
      icon: <HiOutlineMap size={17} />,
    },
    {
      id: "match" as ChildSearchTab,
      label: "CSPPID Match Tool",
      icon: <TbFileSearch size={17} />,
    },
  ];

  return (
    <div className="tab-nav" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          role="tab"
          type="button"
          aria-selected={activeTab === tab.id}
          aria-controls={`tabpanel-${tab.id}`}
          className={`tab-nav-btn${activeTab === tab.id ? " tab-nav-btn--active" : ""}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );
}
